// eslint-disable
// this is an auto generated file. This will be overwritten

// Integration queries
export const listIntegrations = `query ListIntegrations($webAppId: ID) {
  listIntegrations(webAppId: $webAppId) {
    items {
      id
      webAppId
      integrationType
      displayName
      enabled
      createdAt
      updatedAt
      createdBy
      connectionConfig
      eventFilter
      credentialId
      credential {
        credentialSet
        credentialType
        credentialLastRotated
        credentialExpiresAt
        maskedSuffix
      }
      lastDeliveryAt
      lastDeliveryStatus
      lastErrorMessage
      consecutiveFailures
    }
  }
}
`;
export const listIntegrationCredentials = `query ListIntegrationCredentials {
  listIntegrationCredentials {
    items {
      id
      integrationType
      displayName
      credentialType
      maskedSuffix
      credentialLastRotated
      credentialExpiresAt
      createdAt
      updatedAt
      createdBy
    }
  }
}
`;
export const getClient = `query GetClient($clientName: String!) {
  getClient(clientName: $clientName) {
    clientName
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZipCode
    dateRegistered
    govtRegistrationId
    name
    owner
    phone
    website
    highdays
    meddays
    lowdays
    tier
    maxWebApps
    maxConcurrentTests
    accountStatus
  }
}
`;
export const getUser = `query GetUser($id: ID!) {
  getUser(id: $id) {
    given_name
    family_name
    avatar
    emailaddress
    displayName
    phone
    role
    lastlogindate
    currentipaddress
    previpaddress
    city
    country
  }
}
`;
export const listUsers = `query ListUsers($role: String) {
  listUsers(role: $role) {
    items {
      given_name
      family_name
      avatar
      emailaddress
      displayName
      phone
      role
      status
    }
    nextToken
  }
}
`;
export const getWebApplication = `query GetWebApplication($id: ID!) {
  getWebApplication(id: $id) {
    id
    name
    url
    render
    owner
    verificationString
    ownershipVerified
    allowedLinks
    deniedLinks
    apiDomains
    maxRequestsPerSecond
    featureTeamName
    frontEndFramework
    backEndFramework
    dataType
    userType
    testAccounts {
      items {
        id
        owner
        dateAdded
        password
        pin
        totpSecret
        userPriority
        username
      }
      nextToken
    }
    tests {
      items {
        id
        owner
        endTime
        functionCount
        startTime
      }
      nextToken
    }
    dateToTest
    testFrequency
    dateAdded
    abbrev
    color
    securityHeaderName
    securityHeaderValueSet
    testAcknowledged
  }
}
`;
export const getWebApplicationReduced = `query GetWebApplication($id: ID!) {
  getWebApplication(id: $id) {
    id
    name
    url
    render
    owner
    verificationString
    ownershipVerified
    allowedLinks
    deniedLinks
    apiDomains
    maxRequestsPerSecond
    featureTeamName
    frontEndFramework
    backEndFramework
    dataType
    userType
    dateToTest
    testFrequency
    dateAdded
    abbrev
    color
    securityHeaderName
    securityHeaderValueSet
    testAcknowledged
    testAccounts {
      items {
        id
        owner
        dateAdded
        password
        pin
        totpSecret
        userPriority
        username
      }
      nextToken
    }
  }
}
`;

export const getLatestTest = `query GetLatestTest($id: ID!) {
  getLatestTest(id: $id) {
    id
    owner
    endTime
    endTrigger
    functionCount
    startTime
    startTrigger
    vulns {
      items {
        id
        reference
        dateFirstFound
        dateFixed
        dateLastSeen
        owner
        pageUrl
        vulnLocation
        title
        additionalRenders {
          label
          url
        }
        details {
          label
          value
        }
        subFindings {
          title
          description
          riskLevel
          affectedRecord
          expected
          actual
          referenceLink
          referenceLinkNavigable
          stepsToReproduce
          recommendation
          evidence
          httpExchanges {
            label
            method
            url
            requestHeaders { name value }
            requestBody
            responseStatus
            responseHeaders { name value }
            responseBodyExcerpt
            responseBodyTruncated
          }
        }
        render
        videoURL
        stepsToReproduce
        recommendations
        requiresAuthn
        riskRating
        vulnCategory
        vulnName
        vulnStatus
      }
      nextToken
    }
  }
}
`;
export const getWebAppTestStatus = `query GetWebAppTestStatus($id: ID!) {
  getWebAppTestStatus(id: $id) {
    lastTestDate
    currentPhase
    allcrits
    allhighs
    allmeds
    alllows
    opencrits
    openhighs
    openmeds
    openlows
  }
}
`;

export const listWebAppTestStatuses = `query ListWebAppTestStatuses {
  listWebAppTestStatuses {
    id
    lastTestDate
    currentPhase
    allcrits
    allhighs
    allmeds
    alllows
    opencrits
    openhighs
    openmeds
    openlows
  }
}
`;

// Dashboard preload. The testid/startTime/endTime/endTrigger/testStatus
// and vulns fields describe the latest *terminal* test for the webapp
// (see DashboardPreload_BEBrief.md). The inFlight* fields describe a
// separate, optional in-flight test that is more recent than the
// terminal one — used by the FE to drive the "Testing" indicator
// without bundling partial in-flight findings into the dashboard's
// current-state surfaces. Both inFlight* fields are null when no
// in-flight test exists for the webapp. Pre-BE-deploy these fields
// will be absent from the response payload; the FE applyTests handler
// gracefully falls back to deriving the live signal from testStatus
// in that transitional window.
export const listLatestTestsForDashboard = `query ListLatestTestsForDashboard {
  listLatestTestsForDashboard {
    webappid
    testid
    startTime
    endTime
    endTrigger
    testStatus
    inFlightTestStatus
    inFlightStartTime
    vulns {
      id
      webappid
      testid
      reference
      dateFirstFound
      dateLastSeen
      vulnName
      vulnCategory
      riskRating
      vulnStatus
    }
  }
}
`;
export const getTestResults = `query GetTestResults($id: ID!) {
  getTestResults(id: $id) {
    id
    webappid
    owner
    endTime
    endTrigger
    functionCount
    startTime
    startTrigger
    statistics {
      pagesVisited
      apisObserved
      blockedDeniedDomain
      blockedDeniedPath
      blockedSubdomain
      blockedLogout
      captchaPages
      authenticated
      authenticationReason
    }
    testStatus
    testStatusMessage
    retestExpiresAt
    isRetestOf
    originalTestDate
    vulns {
      items {
        id
        reference
        dateFirstFound
        dateFixed
        dateLastSeen
        owner
        pageUrl
        vulnLocation
        title
        additionalRenders {
          label
          url
        }
        details {
          label
          value
        }
        subFindings {
          title
          description
          riskLevel
          affectedRecord
          expected
          actual
          referenceLink
          referenceLinkNavigable
          stepsToReproduce
          recommendation
          evidence
          httpExchanges {
            label
            method
            url
            requestHeaders { name value }
            requestBody
            responseStatus
            responseHeaders { name value }
            responseBodyExcerpt
            responseBodyTruncated
          }
        }
        render
        videoURL
        stepsToReproduce
        recommendations
        requiresAuthn
        riskRating
        vulnCategory
        vulnName
        vulnStatus
      }
      nextToken
    }
  }
}
`;
export const getTestResultsReduced = `query GetTestResults($id: ID!) {
  getTestResults(id: $id) {
    id
    webappid
    owner
    endTime
    endTrigger
    functionCount
    startTime
    startTrigger
    vulns {
      items {
        id
      }
      nextToken
    }
  }
}
`;

// Lean projection used by the in-flight resync path on
// WebApplicationClass. Mirrors the fields the onTestStatusChange
// subscription publishes — so a resync result can be fed through
// the same handler as a live event without divergence — and
// deliberately omits the vulns connection so the periodic poll
// stays cheap even on tests with hundreds of findings.
export const getTestStatusSnapshot = `query GetTestStatusSnapshot($id: ID!) {
  getTestResults(id: $id) {
    id
    webappid
    owner
    endTime
    endTrigger
    functionCount
    startTime
    startTrigger
    testStatus
    testStatusMessage
    retestExpiresAt
    isRetestOf
    originalTestDate
    statistics {
      pagesVisited
      apisObserved
      blockedDeniedDomain
      blockedDeniedPath
      blockedSubdomain
      blockedLogout
      captchaPages
      authenticated
      authenticationReason
    }
  }
}
`;
export const getVulnerabilities = `query GetVulnerabilities($id: ID!) {
  getVulnerabilities(id: $id) {
    id
    webappid
    testid
    reference
    dateFirstFound
    dateFixed
    dateLastSeen
    owner
    pageUrl
    vulnLocation
    title
    additionalRenders {
      label
      url
    }
    details {
      label
      value
    }
    subFindings {
      title
      description
      riskLevel
      affectedRecord
      expected
      actual
      referenceLink
      referenceLinkNavigable
      stepsToReproduce
      recommendation
      evidence
      httpExchanges {
        label
        method
        url
        requestHeaders { name value }
        requestBody
        responseStatus
        responseHeaders { name value }
        responseBodyExcerpt
        responseBodyTruncated
      }
    }
    render
    riskRating
    videoURL
    vulnCategory
    vulnName
    vulnStatus
    stepsToReproduce
    recommendations
    requiresAuthn
  }
}
`;

export const getVulnHistory = `query GetVulnHistory($id: ID!) {
  getVulnHistory(id: $id) {
    highs
    meds
    lows
  }
}
`;

export const listVulnHistories = `query ListVulnHistories {
  listVulnHistories {
    id
    highs
    meds
    lows
  }
}
`;
export const doesUsernameExist = `query doesUsernameExist($username: AWSEmail!) {
  doesUsernameExist(username: $username)
}
`;
export const doesDisplayNameExist = `query doesDisplayNameExist($handle: String!) {
  doesDisplayNameExist(handle: $handle)
}
`;
export const getIsWebApplicationTestRunning = `query getIsWebApplicationTestRunning($webappid: ID!) {
  getIsWebApplicationTestRunning(webappid: $webappid)
}`;
export const getTenantUsage = `query GetTenantUsage {
  getTenantUsage {
    testsUsed
    testsAllowed
    periodResetsAt
    tierLabel
    seatLimit
  }
}
`;
// Per-slot ("app license") detail. Quota is per web app, not tenant-wide, so
// every per-app pentest cue (Applications rows, Pentest button gate) and the
// Billing license list read this. Tenant-scoped server-side by the JWT; readable
// by all roles (incl. Pentester) and exposes no pricing/Stripe data.
export const listTenantEntitlements = `query ListTenantEntitlements {
  listTenantEntitlements {
    id
    planType
    planId
    status
    boundWebAppId
    testsUsedThisPeriod
    testsAllowed
    accessExpiresAt
    periodEndsAt
    createdAt
  }
}
`;
export const quickListWebApplications = `query QuickListWebApplications(
  $filter: ModelWebApplicationFilterInput
  $limit: Int
  $nextToken: String
) {
  quickListWebApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      url
      render
      owner
      verificationString
      ownershipVerified
      allowedLinks
      deniedLinks
      apiDomains
      maxRequestsPerSecond
      featureTeamName
      frontEndFramework
      backEndFramework
      dataType
      userType
      testAccounts {
        items {
          id
          owner
          dateAdded
          password
          pin
          totpSecret
          userPriority
          username
        }
        nextToken
      }
      tests {
        items {
          id
          owner
          endTime
          functionCount
          startTime
        }
        nextToken
      }
      dateToTest
      testFrequency
      dateAdded
      abbrev
      color
      securityHeaderName
      securityHeaderValueSet
      testAcknowledged
    }
    nextToken
  }
}
`;

export const quickListWebApplicationTestUsers = `query QuickListWebApplicationTestUsers(
  $webappid: ID!
  $filter: ModelWebApplicationTestUserFilterInput
  $limit: Int
  $nextToken: String
) {
  quickListWebApplicationTestUsers(
    webappid: $webappid
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      dateAdded
      password
      pin
      totpSecret
      userPriority
      username
    }
    nextToken
  }
}
`;
export const quickListTestResultss = `query QuickListTestResultss(
  $webappid: ID!
  $filter: ModelTestResultsFilterInput
  $limit: Int
  $nextToken: String
) {
  quickListTestResultss(webappid: $webappid, filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      webappid
      owner
      endTime
      endTrigger
      functionCount
      startTime
      startTrigger
      vulns {
        items {
          id
          reference
          dateFirstFound
          dateFixed
          dateLastSeen
          owner
          pageUrl
          vulnLocation
          title
          additionalRenders {
            label
            url
          }
          details {
            label
            value
          }
          subFindings {
            title
            description
            riskLevel
            affectedRecord
            expected
            actual
            referenceLink
            referenceLinkNavigable
            stepsToReproduce
            recommendation
            evidence
            httpExchanges {
              label
              method
              url
              requestHeaders { name value }
              requestBody
              responseStatus
              responseHeaders { name value }
              responseBodyExcerpt
              responseBodyTruncated
            }
          }
          render
          videoURL
          stepsToReproduce
          recommendations
          riskRating
          vulnCategory
          vulnName
          vulnStatus
        }
        nextToken
      }
    }
    nextToken
  }
}
`;
export const quickListVulnerabilitiess = `query QuickListVulnerabilitiess(
  $testid: ID!
  $filter: ModelVulnerabilitiesFilterInput
  $limit: Int
  $nextToken: String
) {
  quickListVulnerabilitiess(testid: $testid, filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      webappid
      reference
      dateFirstFound
      dateFixed
      dateLastSeen
      owner
      pageUrl
      vulnLocation
      title
      additionalRenders {
        label
        url
      }
      details {
        label
        value
      }
      subFindings {
        title
        description
        riskLevel
        affectedRecord
        expected
        actual
        referenceLink
        referenceLinkNavigable
        stepsToReproduce
        recommendation
        evidence
        httpExchanges {
          label
          method
          url
          requestHeaders { name value }
          requestBody
          responseStatus
          responseHeaders { name value }
          responseBodyExcerpt
          responseBodyTruncated
        }
      }
      render
      riskRating
      videoURL
      vulnCategory
      vulnName
      vulnStatus
      stepsToReproduce
      recommendations
      requiresAuthn
    }
    nextToken
  }
}
`;
// Slim findings list for ONE test, used by the in-flight reconcile path
// (WebApplicationClass.resyncInflightFindings → TestResultsClass
// .reconcileLiveFindings). The projection deliberately mirrors the
// onVulnerabilityDiscovered subscription payload rather than the full
// vuln record: no `render` screenshot, no subFindings, no httpExchanges.
// That is what makes it cheap enough to poll every 30s while a test runs
// — the full query above returns every finding's sub-findings along with
// the HTTP request and response bodies captured as evidence.
//
// Same backend query as quickListVulnerabilitiess; only the client's
// selection set differs, so this needs no schema or resolver change.
export const listLiveFindingsForTest = `query ListLiveFindingsForTest(
  $testid: ID!
  $limit: Int
  $nextToken: String
) {
  quickListVulnerabilitiess(testid: $testid, limit: $limit, nextToken: $nextToken) {
    items {
      id
      reference
      riskRating
      vulnName
      vulnCategory
      vulnLocation
      pageUrl
      title
      dateFirstFound
      dateLastSeen
    }
    nextToken
  }
}
`;

// Slim list of a webapp's tests, used to populate the TestSelector
// dropdown on the WebApplication page. testStatus is included so the
// FE can filter to terminal tests (Completed / Invalid / Failed) and
// label each entry with the correct status pill in the dropdown.
export const quickListTestResultssReduced = `query quickListTestResultssReduced(
  $webappid: ID!
  $filter: ModelTestResultsFilterInput
  $limit: Int
  $nextToken: String
) {
  quickListTestResultss(webappid: $webappid, filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      webappid
      owner
      endTime
      endTrigger
      functionCount
      startTime
      startTrigger
      testStatus
    }
    nextToken
  }
}
`;
export const quickListWebApplicationsReduced = `query quickListWebApplicationsReduced(
  $filter: ModelWebApplicationFilterInput
  $limit: Int
  $nextToken: String
) {
  quickListWebApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      url
      render
      owner
      verificationString
      ownershipVerified
      allowedLinks
      deniedLinks
      apiDomains
      maxRequestsPerSecond
      featureTeamName
      frontEndFramework
      backEndFramework
      dataType
      userType
      testAccounts {
        items {
          id
        }
        nextToken
      }
      tests {
        items {
          id
        }
        nextToken
      }
      dateToTest
      testFrequency
      dateAdded
      abbrev
      color
      securityHeaderName
      securityHeaderValueSet
      testAcknowledged
    }
    nextToken
  }
}
`;
export const quickListWebApplicationsSuperReduced = `query quickListWebApplicationsSuperReduced(
  $filter: ModelWebApplicationFilterInput
  $limit: Int
  $nextToken: String
) {
  quickListWebApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      url
      render
      owner
      verificationString
      ownershipVerified
      allowedLinks
      deniedLinks
      apiDomains
      maxRequestsPerSecond
      featureTeamName
      frontEndFramework
      backEndFramework
      dataType
      userType
      dateToTest
      testFrequency
      dateAdded
      abbrev
      color
      securityHeaderName
      securityHeaderValueSet
      testAccounts {
        items {
          id
          owner
          dateAdded
          password
          pin
          totpSecret
          userPriority
          username
        }
        nextToken
      }
    }
    nextToken
  }
}
`;
